const styles = () => ({
    containerService: {
        minHeight: '700px',
    },
    tabsContainer: {
        marginTop: '10px',
        marginBottom: '10px',
    },
    tabs: {
        textTransform: 'none',
    },
});

export default styles;
